import PropTypes from "prop-types";
import React from "react";
import { URLs } from "../utils/apis";
import { Box, Flex, Modal, useMantineTheme } from "@mantine/core";
import CustomButton from "./mantineCustomComponents/CustomButton";
import { useStylesModalCreate } from "../utils/mantine/stampTabContent/useStylesModalCreate";

const BackToFreePlanWindow = ({ setBackToFreeWindow, backToFreeWindow }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesModalCreate } = useStylesModalCreate();

  // Modal
  const closeModal = () => {
    setBackToFreeWindow(false);
  };

  const handleClickBackToFreeWindowClose = () => {
    setBackToFreeWindow(false);
  };

  const handleClickBackToFree = async () => {
    try {
      const response = await fetch(URLs.PADDLE_CANCEL_URL);

      if (!response.ok) {
        setBackToFreeWindow(false);
      }

      window.location.reload();
    } catch (error) {
      setBackToFreeWindow(false);
    }
  };

  return (
    <Modal
      opened={backToFreeWindow}
      onClose={() => closeModal()}
      centered
      size="22rem"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <Box className={classesModalCreate.modalConfirmationTitle}>
        Cancel Your Subscription?
      </Box>
      <Flex
        justify={theme.flex.justify.center}
        gap={theme.flex.gap.large}
        mb={theme.margin.xl}
      >
        <CustomButton
          text="No"
          componentClasses="buttonWhite"
          onClick={() => handleClickBackToFreeWindowClose()}
        ></CustomButton>
        <CustomButton
          text="Yes"
          componentClasses="buttonBlack confirm-stamp-create"
          onClick={() => handleClickBackToFree()}
        ></CustomButton>
      </Flex>
    </Modal>
  );
};
BackToFreePlanWindow.propTypes = {
  setBackToFreeWindow: PropTypes.func,
  backToFreeWindow: PropTypes.bool,
};
export default BackToFreePlanWindow;
